import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("guyana",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                fill="#2A936A" />
            <path
                d="M0 4.5L24 12.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 5.05762L22.3272 12.5003L0 19.9429L0 5.05762Z"
                fill="#FFC20E" />
            <path
                d="M0 4.5L12 12.5L0 20.5L0 4.5Z"
                fill="black" />
            <path
                d="M0 5.12109L11.0664 12.4998L0 19.8784L0 5.12109Z"
                fill="#BE1E2D" />
        </svg>
    `),d=i("guyana_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_129561)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M24 0.5L0 0.5L0 24.5L24 24.5L24 0.5Z"
                    fill="#2A936A" />
                <path
                    d="M0 0.5L24 12.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 1.33594L22.3272 12.4999L0 23.6639L0 1.33594Z"
                    fill="#FFC20E" />
                <path
                    d="M0 0.5L12 12.5L0 24.5L0 0.5Z"
                    fill="black" />
                <path
                    d="M0 1.43164L11.0664 12.4996L0 23.5676L0 1.43164Z"
                    fill="#BE1E2D" />
            </g>
            <defs>
                <clipPath id="clip0_19477_129561">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Guyana,d as GuyanaRounded};
